export interface ICmsComponentContentData {
    contentVariant: ICmsContentVariant;
    contentVideoId?: string;
    contentVideoProvider: ICmsContentVideoProvider;
}
export enum ICmsContentVariant {
    image = 'image',
    video = 'video'
}
export enum ICmsContentVideoProvider {
    youtube = 'youtube',
    vimeo = 'vimeo'
}
export interface ICmsPromotionData {
    promotionEnabled?: boolean;
    promotionId: string;
    promotionName?: string;
    promotionCreative?: string;
    promotionPosition?: number;
}
